import React from 'react';

import { type CardSizes } from '@pkg/components';

import { Timestamp } from './Timestamp';
import { YatUsername } from './YatUsername';

import { Wrapper } from './styles';

interface CardTopProps {
    owner_yat?: string | null;
    owner_twitter?: string | null;
    activity_date?: string | null;
    cardSize?: CardSizes;
}

export const CardTop = ({ owner_yat, owner_twitter, activity_date, cardSize }: CardTopProps) => {
    if (!owner_yat && !activity_date) return null;

    return (
        <Wrapper $cardSize={cardSize}>
            {cardSize !== 'small' && <YatUsername yat={owner_yat} twitter={owner_twitter} cardSize={cardSize} />}
            <Timestamp date={activity_date} />
        </Wrapper>
    );
};
